import { render, staticRenderFns } from "./aypInformation.vue?vue&type=template&id=2ade20c8"
import script from "./aypInformation.vue?vue&type=script&lang=js"
export * from "./aypInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports